import { createDatePicker } from '../../date-picker/date-picker.js';

/** @type {import('../../../contracts/forms.js').FieldDriver} */
export const dateDriver = {
  type: 'date',
  mount(container, ctx) {
    const { def, onChange } = ctx;
    if (!ctx.localeConfig) {
      throw new Error('date-driver: ctx.localeConfig is required');
    }

    const initialValue = ctx.value == null ? '' : String(ctx.value);
    const picker = createDatePicker(container, {
      id: `field-${def.key}`,
      mode: 'date',
      value: initialValue,
      placeholder: def.placeholder ?? 'Pick date',
      localeConfig: ctx.localeConfig,
      ariaLabel: def.required ? undefined : undefined, // visible label exists; no aria-label needed
      onChange: (wire) => onChange(wire),
    });

    if (def.required) {
      const trigger = container.querySelector(`#field-${def.key}`);
      if (trigger) trigger.setAttribute('aria-required', 'true');
    }
    if (def.disabled) picker.setDisabled(true);

    return {
      setValue(value) {
        picker.setValue(value == null ? '' : String(value));
      },
      getValue() {
        return picker.getValue();
      },
      setErrors() {
        // errors rendered by host
      },
      destroy() {
        picker.destroy();
      },
      setDisabled(disabled) {
        picker.setDisabled(disabled);
      },
      clearValue() {
        picker.setValue('');
      },
      setAriaInvalid(invalid) {
        picker.setAriaInvalid(invalid);
      },
    };
  },
};
